<template>
  <v-dialog
    v-model="dialog"
    scrollable
  >
    <template #activator="{ attrs, on }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        icon
      >
        <v-icon>
          mdi-pencil-outline
        </v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="title white--text secondary">
        {{ $t('deliveryEditDialog.title') }}
      </v-card-title>

      <Loading :loading="loading" />

      <v-card-text>
        <v-container
          v-if="model"
          fluid
        >
          <v-row>
            <v-col>
              <v-autocomplete
                v-model="model.data.deliveryType"
                :items="model.metadata.deliveryTypes"
                item-text="text"
                item-value="value"
                :label="$tc('common.type')"
                return-object
                :search-input.sync="deliveryInput"
                auto-select-first
                small-chips
                outlined
dense @input="deliveryInput = null"
              />
              <v-autocomplete
                v-model="model.data.location"
                :items="model.metadata.locations"
                item-text="text"
                item-value="value"
                :label="$tc('common.location')"
                return-object
                :search-input.sync="locationInput"
                auto-select-first
                small-chips
                outlined
dense @input="locationInput = null"
              />
              <v-autocomplete
                v-model="model.data.departments"
                :items="model.metadata.departments"
                item-text="text"
                item-value="value"
                :label="$tc('common.department', 2)"
                return-object
                :search-input.sync="departmentInput"
                auto-select-first
                small-chips
                outlined
dense multiple @input="departmentInput = null"
              />
              <v-autocomplete
                v-model="model.data.subjectAreas"
                :items="model.metadata.subjectAreas"
                item-text="text"
                item-value="value"
                :label="$tc('common.subjectArea', 2)"
                return-object
                :search-input.sync="subjectInput"
                auto-select-first
                small-chips
                outlined
dense multiple @input="subjectInput = null"
              />
              <v-autocomplete
                v-model="model.data.status"
                :items="model.metadata.statuses"
                item-text="text"
                item-value="value"
                :label="$t('common.status')"
                return-object
                :search-input.sync="statusInput"
                auto-select-first
                small-chips
                outlined
dense @input="statusInput = null"
              />
            </v-col>
            <v-col>
              <v-autocomplete
                v-model="model.data.followerPersons"
                :items="model.metadata.persons"
                item-text="text"
                item-value="value"
                :label="$tc('common.follower', 2)"
                return-object
                :search-input.sync="followerPersonsInput"
                auto-select-first
                small-chips
                outlined
dense multiple @input="followerPersonsInput = null"
              />
              <v-textarea
                v-model="model.data.waitingForAction"
                :label="$t('deliveryEditDialog.waitingForAction')"
                outlined
                dense
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              sm="4"
            >
              <!--
              <DatePick label="Forv start" clearable="false" :date="model.data.expectedStart" />
              <DatePick label="Forv slut" clearable="false" :date="model.data.expectedEnd" />
              <DatePick label="Start" clearable="true" :date="model.data.startedOn" />
              <DatePick label="Slut" clearable="true" :date="model.data.endedOn" />
              -->
              <v-menu
                v-for="input in dateInputs.slice(0, 4)"
                :key="input.name"
                v-model="input.menu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template #activator="{ on, attrs }">
                  <v-text-field
                    v-model="model.data[input.name]"
                    :label="input.label"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                  />
                </template>
                <v-date-picker
                  v-model="model.data[input.name]"
                  @input="input.menu = false"
                />
              </v-menu>
            </v-col>

            <v-col
              cols="12"
              sm="4"
            >
              <v-menu
                v-for="input in dateInputs.slice(4, 8)"
                :key="input.name"
                v-model="input.menu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template #activator="{ on, attrs }">
                  <v-text-field
                    v-model="model.data[input.name]"
                    :label="input.label"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                  />
                </template>
                <v-date-picker
                  v-model="model.data[input.name]"
                  @input="input.menu = false"
                />
              </v-menu>
            </v-col>

            <v-col
              cols="12"
              sm="4"
            >
              <v-menu
                v-for="input in dateInputs.slice(8)"
                :key="input.name"
                v-model="input.menu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template #activator="{ on, attrs }">
                  <v-text-field
                    v-model="model.data[input.name]"
                    :label="input.label"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                  />
                </template>
                <v-date-picker
                  v-model="model.data[input.name]"
                  @input="input.menu = false"
                />
              </v-menu>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="model.data.title"
                :label="$t('common.title')"
                outlined
                dense
              />
              <v-currency-field
                v-model="model.data.expectedConsultants"
                :label="$t('taskRequestEditDialog.expectedConsultants')"
                outlined
                dense
              />
              <v-currency-field
                v-model="model.data.expectedDays"
                :label="$t('taskRequestEditDialog.expectedDays')"
                outlined
                dense
              />
              <v-currency-field
                v-model="model.data.expectedPrice"
                :label="$t('taskRequestEditDialog.expectedPrice')"
                outlined
                dense
              />
              <v-text-field
                v-model="model.data.externalReference"
                :label="$t('deliveryDetail.externalReference')"
                outlined
                dense
              />
            </v-col>
            <v-col>
              <v-textarea
                v-model="model.data.description"
                :label="$t('common.description')"
                outlined
                dense
              />
              <v-textarea
                v-model="model.data.focusPoints"
                :label="$t('deliveryCard.focusPoints')"
                outlined
                dense
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          outlined
          color="primary"
          @click="cancel"
        >
          {{ $t('common.cancel') }}
        </v-btn>
        <v-btn
          color="secondary"
          :loading="saving"
          @click="save"
        >
          {{ $t('common.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Loading from '@/components/Loading.vue';

export default {
  name: 'DeliveryEditDialog',
  components: {
    Loading
  },
  data() {
    return {
      dialog: false,
      loading: false,
      saving: false,
      model: null,
      deliveryInput: null,
      locationInput: null,
      departmentInput: null,
      subjectInput: null,
      statusInput: null,
      followerPersonsInput: null,
      dateInputs: [
        {
          name: 'expectedStart',
          label: 'Forv. start',
          menu: false
        },
        {
          name: 'expectedEnd',
          label: 'Forv. slut',
          menu: false
        },
        {
          name: 'startedOn',
          label: 'Faktisk start',
          menu: false
        },
        {
          name: 'endedOn',
          label: 'Faktisk slut',
          menu: false
        },
        {
          name: 'expectedDeliveryDescriptionApprovedOn',
          label: 'Forv. lev. godk.',
          menu: false
        },
        {
          name: 'expectedPartsReadyForShipmentOn',
          label: 'Forv. mat. klar i DK',
          menu: false
        },
        {
          name: 'expectedWorkStartedOn',
          label: 'Forv. udførsel start',
          menu: false
        },
        {
          name: 'expectedWorkEndedOn',
          label: 'Forv. udførsel slut',
          menu: false
        },
        {
          name: 'deliveryDescriptionApprovedOn',
          label: 'Lev. godk.',
          menu: false
        },
        {
          name: 'partsReadyForShipmentOn',
          label: 'Mat. klar i DK',
          menu: false
        },
        {
          name: 'workStartedOn',
          label: 'Udførsel start',
          menu: false
        },
        {
          name: 'workEndedOn',
          label: 'Udførsel slut',
          menu: false
        },
        {
          name: 'closedOn',
          label: 'Leverance lukket',
          menu: false
        },
      ]
    };
  },
  watch: {
    dialog(value) {
      if (value) {
        this.fetchData();
      }
    }
  },
  methods: {
    fetchData: async function () {
      this.loading = true;

      try {
        const response = await this.$api.get(`delivery/edit/${this.$route.params.id}`);
        this.model = response.data;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    save: async function () {
      this.saving = true;

      try {
        await this.$api.put(`delivery/edit/${this.$route.params.id}`, this.model.data);

        this.dialog = false;
        this.$emit('saved');
      } catch (error) {
        console.error(error);
      } finally {
        this.saving = false;
      }
    },
    cancel: function () {
      this.dialog = false;
    }
  }
};
</script>